import { Scalars } from '../../../../types/dato';
import { SchemaMerged } from '../../../../types/IHeader';

export const overideSchema = (initialDatas?: any, newDatas?: any) => {
  if (newDatas && initialDatas) {
    const overridenSchema = { ...initialDatas, ...newDatas };
    return overridenSchema;
  } else if (newDatas && !initialDatas) {
    return newDatas;
  }
  return initialDatas;
};

export const jsonDecodeAllSchema = (allSchema: Scalars['JSON'][]) => {
  return allSchema.map((elt) => JSON.parse(elt?.json));
};

export const addTypeElement = (
  webPage: SchemaMerged,
  type: string[],
): SchemaMerged => {
  const webPageType: any = webPage?.['@type'] ? webPage?.['@type'] : {};
  const newType = Array.isArray(webPage?.['@type'])
    ? [...webPageType, ...type]
    : [webPageType, ...type];

  const additionnalData = {
    '@type': Array.from(new Set(newType)),
  };
  return { ...webPage, ...additionnalData };
};
